import dayjs from 'dayjs';
import { useFormContext } from 'react-hook-form';
import { HookInput } from '@/components/UI/HookForm/Form/Input';
import useUpdateEffect from '@/hooks/useUpdateEffect';
import type { MilestoneChangeOrderSchema } from './validationSchema';

export function ChangeInDaysInput() {
  const formMethods = useFormContext<MilestoneChangeOrderSchema>();
  const milestone = formMethods.watch('milestone');
  const proposedDueDate = formMethods.watch('proposedDueDate');

  useUpdateEffect(() => {
    if (milestone?.dueDate) {
      const diffInDays = dayjs(proposedDueDate).diff(dayjs(milestone.dueDate).startOf('day'), 'day', true);

      formMethods.setValue('changeInDays', diffInDays);
    } else {
      formMethods.setValue('changeInDays', 0);
    }
  }, [milestone, proposedDueDate]);

  return <HookInput formMethods={formMethods} label='Change in Days' disabled type='number' id='changeInDays' name='changeInDays' />;
}
